import React, { useState, useRef } from "react";
import TimeAgo from "react-timeago";
import Countdown from "react-countdown-now";

function PatientActivityListing({ items = [], onTake }) {
    // local state
    const [active, setActive] = useState(null);
    const obRef = useRef();
    if (!items.length)
        return (
            <div className="col-md-12 text-center">
                <div className="card">
                    <div className="card-body m-5" style={{ minHeight: "420px" }}>
                        <h4 className="text-pink mt-5">No Activity has been recorded for this patient!</h4>
                    </div>
                </div>
            </div>
        );
    if (active)
        return (
            <div className="row justify-content-center fade-in">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                <button onClick={() => setActive(null)} title="Back" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored">
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                <TimeAgo date={new Date(active.datetime)} />
                            </header>
                        </div>
                        <div className="card-body">
                            <center>
                                <div
                                    style={{
                                        backgroundImage: `url(${active.category.image}`,
                                        width: "80px",
                                        height: "80px",
                                    }}
                                    className="img-container user-img-circle"
                                ></div>
                                <br />
                                <strong
                                    style={{
                                        fontSize: "1.2rem",
                                        marginTop: "1rem",
                                    }}
                                >
                                    {active.category.name}
                                </strong>
                                <br />
                                <span className="text-muted">Activity</span>
                            </center>

                            <form>
                                {/* <div className="form-group">
									<label htmlFor="datetime-id">
										Observation (if any)
									</label>
									
								</div>
								<div className="form-group text-right fade-in">
									<button
										type="submit"
										className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success"
									>
										Submit
										<i className="material-icons">
											arrow_right_alt
										</i>
									</button>
								</div> */}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    return (
        <div className="row">
            {items.map((item, idx) => (
                <div key={idx} className="col-md-6 col-sm-6 col-xs-12 col-lg-4 fade-in">
                    <div className="card">
                        <div className="card-body text-center">
                            <div className="row">
                                <div className="col-lg-4">
                                    <center>
                                        <div
                                            style={{
                                                backgroundImage: `url(${item.category.image}`,
                                                width: "70px",
                                                height: "70px",
                                            }}
                                            className="img-container user-img-circle"
                                        ></div>
                                    </center>
                                    <span className="badge badge-success">{item.category.name}</span>
                                </div>
                                <div className="col-lg-8">
                                    <span className="badge badge-primary">
                                        <TimeAgo date={new Date(item.datetime)} />
                                    </span>
                                    <br />
                                    <strong>
                                        {Intl.DateTimeFormat("en-GB", {
                                            weekday: "short",
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                            hour12: false,
                                            minute: "numeric",
                                            second: "numeric",
                                            hour: "numeric",
                                        }).format(new Date(item.datetime))}{" "}
                                    </strong>
                                    <p>
                                        {item.taken.status ? (
                                            <span className="badge badge-success">Completed</span>
                                        ) : (
                                            <span className="badge badge-danger">
                                                <Countdown date={new Date(item.datetime)} />
                                            </span>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="card-body">
							<div className="form-group">
								<label htmlFor="observation">
									Observation (if any)
								</label>
								<textarea
									name="observation"
									id="observation"
									cols="30"
									rows="4"
									className="form-control form-control-textarea"
								></textarea>
							</div>
						</div> */}
                        {item.taken.status && (
                            <div className="card-body fade-in">
                                <p>{item.taken.observation}</p>
                            </div>
                        )}
                        <div className="card-footer">
                            {!item.taken.status && (
                                <form
                                    onSubmit={(event) => {
                                        event.preventDefault();
                                        onTake({
                                            id: item.id,
                                            observation: obRef.current.value,
                                        });
                                    }}
                                >
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control input-height"
                                            id={item.id}
                                            ref={obRef}
                                            name="observation-id"
                                            aria-describedby="observation-id"
                                            placeholder="enter observation"
                                        />
                                    </div>
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success btn-block">
                                        Done
                                        <i className="material-icons">arrow_right_alt</i>
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default PatientActivityListing;
